export default {
  sihuaLu: 'Lộc',
  sihuaQuan: 'Quyền',
  sihuaKe: 'Khoa',
  sihuaJi: 'Kỵ',
} as const;
